import React from 'react';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import { Link } from 'react-router-dom';

function index({ imageId, title, desc, link, serialNo }) {

    return (
        <div className='mod-search-item'>
            <Link to={link} className='mod-search-item__link'></Link>
            <div className='mod-search-item__img-wrap'>
                <CloudinaryAdvancedImage imagePublicId={imageId} className='mod-search-item__image' type="square-collection-thumbnail" />
            </div>
            <div className='mod-search-item__info-wrap'>
                <h3 className='mod-search-item__title'>{title}</h3>
                <p className='mod-search-item__desc'>{serialNo && <span>Sr. No. {serialNo}</span>} {desc}</p>
            </div>
        </div>
    )
}

export default index